import React from 'react';
import FarmDetailsComponents from "../../components/FarmsComponents/FarmDetailsComponents";
import { Link } from "react-router-dom";
import Auth from "../../services/Auth.service";
import { useTranslation } from "react-i18next";
import NavegacionFarms from "../../components/NavigableComponents/NavigableFarms";
import FarmsService from "../../services/farms.service";

export default function FarmDetails(props) {

    const { t } = useTranslation();
    const { params } = props.match;
    const [farm, setFarm] = React.useState({
        "farmId": 0,
        "integratorId": 0,
        "integratorCode": "",
        "manufacturerCode": "",
        "name": "",
        "officialMark": "",
        "regaCode": "",
        "gpsCordinates": "",
        "address": "",
        "city": "",
        "postcode": "",
        "provinceId": 0,
        "countryId": "",
        "remarks": "",
        "isInactive": true,
        "region": "",
        "distributionZoneId": 0,
        "farmTypeId": 0,
        "efficiencyRatio": 0
    });

    React.useEffect(() => {
        FarmsService.getFarm(params.farmId)
            .then(response => response.data)
            .then(json => {
                setFarm({
                    "farmId": json.contract.farmId,
                    "integratorId": json.contract.integratorId,
                    "integratorCode": json.contract.integratorCode,
                    "manufacturerCode": json.contract.manufacturerCode,
                    "name": json.contract.name,
                    "officialMark": json.contract.officialMark,
                    "regaCode": json.contract.regaCode,
                    "gpsCordinates": json.contract.gpsCordinates,
                    "address": json.contract.address,
                    "city": json.contract.city,
                    "postcode": json.contract.postcode,
                    "provinceId": json.contract.provinceId,
                    "countryId": json.contract.countryId,
                    "remarks": json.contract.remarks,
                    "isInactive": json.contract.isInactive,
                    "region": json.contract.region,
                    "distributionZoneId": json.contract.distributionZoneId,
                    "farmTypeId": json.contract.farmTypeId,
                    "efficiencyRatio": json.contract.efficiencyRatio
                });

            });
    }, [params.farmId]);

    return (
        <div>
            {Auth.isUserLoged ? <div>
                <br />
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-0"> {/* Añadí mb-0 para eliminar margen inferior */}
                                <li className="breadcrumb-item"><Link to={'/home/'}>{t("Home_Breadcrumb_Title")}</Link></li>
                                <li className="breadcrumb-item"><Link to={'/Farms/'}>{t("Global_Label_Text_Farms")}</Link></li>
                                <li className="breadcrumb-item"><Link to={'/Farms/' + farm.farmId + '/GeneralInformation'}>{farm.name}</Link></li>
                                <li className="breadcrumb-item"><Link to={'/Farms/' + farm.farmId + '/Details'}>{t("Global_Label_Text_Details")}</Link></li>
                            </ol>
                        </nav>
                        <NavegacionFarms farmId={farm.farmId} />
                    </div>
                </div>

                <div>
                    <FarmDetailsComponents
                        farm={farm}
                    />
                </div>
                <br />
            </div > : ""}
        </div>
    );

}
